module.exports = __webpack_public_path__ + "img/b-3.8932973.png";